import React from 'react'
import { Grid } from 'semantic-ui-react'
import { withSystemConfig } from 'shared'
// @ts-ignore
import LKButton from 'shared/LKButton'
// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'
import isUndefined from 'lodash/isUndefined'

import { isRequired } from '../../../helpers'
import translate, { translateWeb } from '../../translate'
import { requestTypes, FORM_NAME } from '../../../constants'

import container from './container'
import { SMSSendParams } from '../../../models/contact-info.models'
import { translate as mainTranslate } from 'loankeeper-common/helpers'
import { clientContactSendSMS, clientContactVerifySMS } from 'src/store/client'
import { connect } from 'react-redux'
import { AppDispatch } from 'src/store/index.d'

//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => {
  return {
    clientContactSendSMS: (params) => dispatch(clientContactSendSMS(params)),
    clientContactVerifySMS: (params) => dispatch(clientContactVerifySMS(params)),
  }
})
@withSystemConfig('CellPhoneValidate')
class BusinessContactInformation extends React.Component<any> {
  state = {
    recentCodeSent: false,
    CodeVerifyPass: false,
    SMSCodeSent: false,
    CodeVerifyClicked: false,
    timerStarted: false,
    timeLeft: 60,
    cellPhoneOldValue: '',
    isOldValueSame: false,
    codeVerifyLoading: false,
  }
  intervalRef: any

  constructor(props) {
    super(props)

    if (!props.CodeVerifyPass) {
      props.changeFormValue('CodeVerifyPass', 0)
    }
    if (!props.SMSCodeSent) {
      props.changeFormValue('SMSCodeSent', 0)
    }
    if (!props.CodeVerifyClicked) {
      props.changeFormValue('CodeVerifyClicked', 0)
    }

    this.intervalRef = React.createRef()
  }

  componentDidMount = () => {
    const CodeVerifyPass = this.props.CodeVerifyPass === 1
    const SMSCodeSent = this.props.SMSCodeSent === 1
    const CodeVerifyClicked = this.props.CodeVerifyClicked === 1
    this.setState({ CodeVerifyPass, SMSCodeSent, CodeVerifyClicked })
  }

  componentWillUnmount = () => {
    const { CodeVerifyPass, SMSCodeSent, CodeVerifyClicked } = this.state
    const { changeFormValue } = this.props
    changeFormValue('CodeVerifyPass', CodeVerifyPass ? 1 : 0)
    changeFormValue('SMSCodeSent', SMSCodeSent ? 1 : 0)
    changeFormValue('CodeVerifyClicked', CodeVerifyClicked ? 1 : 0)
    this.stopTimer()
  }

  handleSendSMSCode = async () => {
    const { CardNumber, CellPhone, actionType, params, IDCardTypeID } = this.props
    let apiParams = {} as Partial<SMSSendParams>

    if (actionType === requestTypes.update) {
      apiParams = { CellPhone, ClientID: params.ID, ClientHash: params.hash, IDCardTypeID }
    } else {
      apiParams = { PersonalNo: CardNumber, CellPhone, IDCardTypeID }
    }

    this.handleStartTimer()
    // @ts-ignore
    // Client.contactVerifySendSMS(apiParams)
    //   .then(() => {
    //     this.setState({ SMSCodeSent: true, recentCodeSent: true, CodeVerifyClicked: false, CodeVerifyPass: false })
    //   })
    //   .catch((err) => {
    //     this.setState({ SMSCodeSent: false, recentCodeSent: true })
    //     console.error(err)
    //   })
    // setTimeout(() => this.setState({ recentCodeSent: false }), 3000)

    //UPDATED API REQUEST client_contact_verify_api action: send_sms
    try {
      const res = await this.props.clientContactSendSMS(apiParams)
      if (res.error) {
        this.setState({ SMSCodeSent: false, recentCodeSent: true })
        this.props.openErrorModal(translateWeb(res.payload))
        return
      }
      this.setState({ SMSCodeSent: true, recentCodeSent: true, CodeVerifyClicked: false, CodeVerifyPass: false })
    } catch (error) {
      this.setState({ SMSCodeSent: false, recentCodeSent: true })
      console.error(error)
    }
    setTimeout(() => this.setState({ recentCodeSent: false }), 3000)
  }

  handleVerifySMSCode = async () => {
    if (this.state.codeVerifyLoading) return
    this.setState({ codeVerifyLoading: true })
    const { CardNumber, CellPhone, IDCardTypeID, CellPhoneValidateCode, actionType, params, changeFormValue } =
      this.props

    const { CodeVerifyPass } = this.state

    if (!CellPhoneValidateCode || CellPhoneValidateCode.toString().trim() === '') {
      if (CodeVerifyPass) this.setState({ CodeVerifyPass: false })
    } else {
      let apiParams = {}
      if (actionType === requestTypes.update) {
        apiParams = {
          CellPhone,
          Code: CellPhoneValidateCode,
          ClientID: params.ID,
          ClientHash: params.hash,
          IDCardTypeID,
        }
      } else {
        apiParams = { PersonalNo: CardNumber, CellPhone, Code: CellPhoneValidateCode, IDCardTypeID }
      }
      // @ts-ignore
      // Client.contactVerifySMS(apiParams)
      //   .then(() => {
      //     this.setState({ CodeVerifyPass: true, CodeVerifyClicked: true, codeVerifyLoading: false })
      //     changeFormValue('CodeVerifyPass', 1)
      //   })
      //   .catch((err) => {
      //     this.props.openErrorModal(translateWeb('ERR_CODE_NOT_FOUND'))
      //     this.setState({ CodeVerifyPass: false, CodeVerifyClicked: true, codeVerifyLoading: false })
      //     changeFormValue('CodeVerifyPass', 0)
      //     console.error(err)
      //   })

      //UPDATED API REQUEST client_contact_verify_api action: verify_sms
      try {
        const res = await this.props.clientContactVerifySMS(apiParams)
        if (res.error) {
          this.props.openErrorModal(translateWeb('ERR_CODE_NOT_FOUND'))
          this.setState({ CodeVerifyPass: false, CodeVerifyClicked: true, codeVerifyLoading: false })
          changeFormValue('CodeVerifyPass', 0)
          console.error(res.error)
        }
        this.setState({ CodeVerifyPass: true, CodeVerifyClicked: true, codeVerifyLoading: false })
        changeFormValue('CodeVerifyPass', 1)
      } catch (err) {
        this.props.openErrorModal(translateWeb('ERR_CODE_NOT_FOUND'))
        this.setState({ CodeVerifyPass: false, CodeVerifyClicked: true, codeVerifyLoading: false })
        changeFormValue('CodeVerifyPass', 0)
        console.error(err)
      }
    }
  }

  componentWillReceiveProps(nextProps: Readonly<any>, nextContext: any): void {
    if (nextProps?.CellPhone?.length === 9) {
      this.setState((prevState: any) => {
        const isSame = prevState.cellPhoneOldValue === nextProps.CellPhone
        if (!isSame) {
          this.stopTimer()
        }
        return {
          isOldValueSame: isSame,
          cellPhoneOldValue: nextProps.CellPhone,
        }
      })
    }
  }

  handleStartTimer = () => {
    if (this.state.timerStarted) return
    this.setState({ timerStarted: true })
    this.intervalRef.current = setInterval(() => {
      if (this.state.timeLeft > 0) {
        this.setState((prevState: any) => ({
          timeLeft: prevState.timeLeft - 1,
        }))
      } else {
        this.stopTimer()
      }
    }, 1000)
  }

  stopTimer = () => {
    this.setState({ timerStarted: false, timeLeft: 60 })
    clearInterval(this.intervalRef.current)
  }

  render() {
    const {
      fields,
      selects,
      cityList,
      dynamicOptions,
      copyAddressFromCurrentAddress,
      noVisibilityFilter,
      onTranslateAltRequest,
      onCountryChange,
      actionType,
      permissions,
      CellPhoneValidate,
      CardNumber,
      CellPhoneValidateCode,
      CellPhone,
      FormAsyncErrors,
      clearCellPhoneValidateCode,
    } = this.props
    const { CodeVerifyPass, CodeVerifyClicked, SMSCodeSent, recentCodeSent, codeVerifyLoading } = this.state

    const CardNumberErr = FormAsyncErrors ? FormAsyncErrors.CardNumber : undefined

    const isCardNumberErr = !isUndefined(CardNumberErr)
    return (
      <GridContainer smallPadding>
        <Grid.Column width={16}>
          {(!!fields.CityBusID || !!fields.AddressBus) && (
            <FormLayout
              fieldProportions="3:3:6:3:1"
              label={translate('lbl_bus_address')}
              visible={noVisibilityFilter || !!fields.AddressBus}
            >
              {!!selects.Country && (
                <FormField
                  name="CountryBusID"
                  onChange={(value) => onCountryChange(value, 'CityBusID')}
                  options={selects.Country}
                  type="select"
                  search
                />
              )}
              {!!fields.CityBusID && (
                <FormField
                  visible={noVisibilityFilter || !!fields.CityBusID}
                  name="CityBusID"
                  options={cityList.CityBusIDList}
                  required={isRequired(fields.CityBusID)}
                  flags={
                    fields.CityBusID && {
                      modifies: {
                        modifier: 'CityBusID',
                        modifierAlias: 'CityID',
                        field: { DistrictBusID: selects.District },
                        dependent: {
                          modifier: 'DistrictBusID',
                          modifierAlias: 'DistrictID',
                          field: { ZoneBusID: selects.Zone },
                          form: FORM_NAME,
                        },
                        form: FORM_NAME,
                      },
                    }
                  }
                  type="select"
                  search
                />
              )}
              {!!fields.AddressBus && (
                <FormField
                  name="AddressBus"
                  required={isRequired(fields.AddressBus)}
                  type="text"
                  maxLength={fields.AddressBus ? fields.AddressBus.MaxLen : -1}
                  onBlur={onTranslateAltRequest('AddressBus_ALT')}
                />
              )}
              <FormField
                name="AddressBus_ALT"
                placeholder={translate('txt_address_bus_alt')}
                required={isRequired(fields.AddressBus_ALT)}
                type="text"
                maxLength={fields.AddressBus_ALT ? fields.AddressBus_ALT.MaxLen : -1}
              />
              <LKButton alias="down_big" onClick={copyAddressFromCurrentAddress} />
            </FormLayout>
          )}

          {(!!fields.CityBusID || !!fields.DistrictBusID || !!fields.ZoneBusID) && (
            <FormLayout
              visible={noVisibilityFilter || !!(fields.CityBusID || fields.DistrictBusID || fields.ZoneBusID)}
              label={translate('lbl_location3')}
            >
              {!!fields.DistrictBusID && (
                <FormField
                  visible={noVisibilityFilter || !!fields.DistrictBusID}
                  name="DistrictBusID"
                  options={dynamicOptions.District}
                  required={isRequired(fields.DistrictBusID)}
                  flags={
                    fields.DistrictBusID && {
                      modifies: {
                        modifier: 'DistrictBusID',
                        modifierAlias: 'DistrictID',
                        field: { ZoneBusID: selects.Zone },
                        form: FORM_NAME,
                      },
                    }
                  }
                  type="select"
                  search
                />
              )}
              {!!fields.ZoneBusID && (
                <FormField
                  visible={noVisibilityFilter || !!fields.ZoneBusID}
                  name="ZoneBusID"
                  options={dynamicOptions.Zone}
                  required={isRequired(fields.ZoneBusID)}
                  type="select"
                  search
                />
              )}
            </FormLayout>
          )}
          {(!!fields.Email || !!fields.Email1) && (
            <FormLayout
              visible={noVisibilityFilter || !!(fields.Email || fields.Email1)}
              label={translate('lbl_email')}
            >
              {!!fields.Email && (
                <FormField
                  visible={noVisibilityFilter || !!fields.Email}
                  name="Email"
                  required={isRequired(fields.Email)}
                  type="text"
                  maxLength={fields.Email ? fields.Email.MaxLen : -1}
                />
              )}
              {!!fields.Email1 && (
                <FormField
                  visible={noVisibilityFilter || !!fields.Email1}
                  name="Email1"
                  required={isRequired(fields.Email1)}
                  type="text"
                  maxLength={fields.Email ? fields.Email.MaxLen : -1}
                />
              )}
            </FormLayout>
          )}
          {(!!fields.Phone || !!fields.CellPhone) && (
            <FormLayout
              visible={noVisibilityFilter || !!(fields.Phone || fields.CellPhone)}
              fieldProportions="8:5:3"
              label={translate('lbl_phone')}
            >
              {!!fields.Phone && (
                <FormField
                  visible={noVisibilityFilter || !!fields.Phone}
                  name="Phone"
                  dontParseToInt
                  maxLength={fields.Phone && fields.Phone.MaxLen}
                  required={isRequired(fields.Phone)}
                  type="number"
                />
              )}
              {!!fields.CellPhone && (
                <FormField
                  disabled={
                    actionType === requestTypes.update &&
                    (!permissions.VIEW_CLIENT || !permissions.EDIT_CLIENT || !permissions.EDIT_CLIENT_CELLPHONE)
                  }
                  visible={noVisibilityFilter || !!fields.CellPhone}
                  name="CellPhone"
                  onChange={() => {
                    this.setState({ SMSCodeSent: false, CodeVerifyClicked: false, CodeVerifyPass: false })
                    clearCellPhoneValidateCode()
                  }}
                  dontParseToInt
                  minLength={9}
                  maxLength={9}
                  required={isRequired(fields.CellPhone)}
                  type="number"
                />
              )}

              <LKButton
                alias="sms"
                onClick={this.handleSendSMSCode}
                disabled={
                  CellPhoneValidate === '0' ||
                  recentCodeSent ||
                  !CardNumber ||
                  CardNumber.toString().trim() === '' ||
                  isCardNumberErr ||
                  !CellPhone ||
                  CellPhone.toString().length < 9 ||
                  this.state.timerStarted ||
                  CodeVerifyPass
                }
                icon
              >
                {mainTranslate('frm_sms_send-cmd_send_queue')}
              </LKButton>
            </FormLayout>
          )}
          {CellPhoneValidate === '1' && (!!fields.Phone || !!fields.CellPhone) && (
            <FormLayout
              visible={noVisibilityFilter || CellPhoneValidate === '1'}
              label=" "
              fieldProportions="8:4:1:1:1:1"
            >
              <div style={{ textAlign: 'right' }}>{translate('lbl_sms_code')}</div>

              <FormField
                visible={noVisibilityFilter || CellPhoneValidate === '1'}
                disabled={!SMSCodeSent || CodeVerifyPass}
                name="CellPhoneValidateCode"
                onChange={() => this.setState({ CodeVerifyClicked: false })}
                required={isRequired(fields.CellPhone)}
                type="number"
                maxLength={6}
                minLength={4}
              />

              <LKButton
                alias="verification"
                onClick={this.handleVerifySMSCode}
                disabled={
                  CodeVerifyPass ||
                  codeVerifyLoading ||
                  !SMSCodeSent ||
                  !CellPhoneValidateCode ||
                  !(CellPhoneValidateCode.toString().length === 4 || CellPhoneValidateCode.toString().length === 6)
                }
                icon
              />

              {CodeVerifyClicked ? (
                <LKButton
                  tabIndex="-1"
                  className="Tree-toggleExpand"
                  style={{ height: 30, cursor: 'default', pointerEvents: 'none' }}
                  alias={CodeVerifyPass ? 'ok' : 'cancel'}
                />
              ) : (
                <div>&nbsp;</div>
              )}
              <FormField name="CodeVerifyPass" type="hidden" value={CodeVerifyPass} />

              {/* <div style={{ textAlign: 'right' }}>
                <LKButton
                  alias="chip"
                  onClick={this.handleVerifySMSCode}
                  disabled={!SMSCodeSent || !CellPhoneValidateCode || CellPhoneValidateCode.toString().length < 4}
                  icon
                />
              </div>
              <div> &nbsp;</div> */}
            </FormLayout>
          )}
        </Grid.Column>
      </GridContainer>
    )
  }
}

export default container(BusinessContactInformation)
